import React, { useContext, useEffect, useRef, useState } from 'react'
import { AuthContext } from '../../context/AuthContext';
import useAxios from '../../common/hook/useAxios';
import { toast } from 'react-toastify';
import { extractDate, formatDate, formatDateForInput, formatDateForInput1, parseDateString, parseDateString1 } from '../../constant';
import { FaPrint } from 'react-icons/fa6';
import { FaSearch } from 'react-icons/fa';
import { AiOutlineFileExcel } from 'react-icons/ai';
import { MdPictureAsPdf } from 'react-icons/md';

const PatientList = () => {
    const dataTableRef = useRef();
    const { user } = useContext(AuthContext)
    const { request } = useAxios()
    const [patientList, setPatientList] = useState([])
    const [searchTerm, setSearchTerm] = useState("")
    const [dob, setDob] = useState("")
    const [DOS, setDOS] = useState(new Date())
    const [error, setError] = useState("")
    const [searchIns, setSearchIns] = useState("")
    const [policy, setPolicy] = useState("")
    const [selectedRows, setSelectedRows] = useState({});
    const [location, setLocation] = useState("")


    const columns = [
        { key: "location", label: "Location", filter: location, onChange: setLocation, accessor: row => row.LocationName },
        { key: "appointmentDate", label: "Appointment Date", accessor: row => row.AppointmentDate },
        {
            key: "patientName", label: "Patient Name", filter: searchTerm, onChange: setSearchTerm, accessor: row => (
                <p className='text-blue-700 cursor-pointer underline' onClick={() => {
                    const url = `/patient-dashboard?patientId=${row.PatientID}&patientName=${encodeURIComponent(row.FirstName + row.LastName)}`;
                    window.open(url, "_blank");
                }}>{row.LastName}, {row.FirstName}</p>
            )
        },
        { key: "gender", label: "Gender", accessor: row => row.Gender },
        { key: "dob", label: "DOB", filter: dob, onChange: setDob, accessor: row => row.DOB },
        { key: "contactNumber", label: "Contact Number", accessor: row => row.ContactNumber },
        { key: "appointmentTime", label: "Appointment Time", accessor: row => row.AppointmentTime },
        { key: "insurance", label: "Insurance", filter: searchIns, onChange: setSearchIns, accessor: row => row.Insurance },
        { key: "policy", label: "#Policy", filter: policy, onChange: setPolicy, accessor: row => row.PolicyNumber },
        { key: "pocResult", label: "POC Result", accessor: row => <div dangerouslySetInnerHTML={{ __html: row.POCResult }} /> },
    ];
    const [printVisibleColumns, setPrintVisibleColumns] = useState(columns.map(c => c.key));

    useEffect(() => {
        getPatientList()
    }, [])

    const getPatientList = () => {
        const dos = formatDate(DOS)
        const url = `${process.env.REACT_APP_APPOINTMENT_URL}/Appointment/AppointmentPatientList?sInputJSON={"PracticeId":"${user?.PracticeID}","DOS":"${dos}","Offset":"${user?.DefaultTimeZoneOffSet}"}`;
        request(url, {
            headers: {
                Authorization: `Bearer ${user?.AuthToken}`,
            },
            method: "GET",
        })
            .then((res) => {
                setPatientList(res);
            })
            .catch(() => {
                toast.error("Error occurred while fetching labs", {
                    autoClose: 3000,
                });
            });
    };

    const getPrintClass = (key) => {
        return printVisibleColumns.includes(key) ? '' : 'print-hidden';
    };

    // const handlePrint = (patientName, dob) => {
    //     const now = new Date();
    //     const date = now.toLocaleDateString();
    //     const time = now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    //     const curTime = `${date} ; ${time}`
    //     let sHtml = "<style media='print'>@page { margin: 0mm;  /* this affects the margin in the printer settings */";
    //     sHtml += "  }  body  {  background-color: #FFFFFF; border: solid 1px black;";
    //     sHtml += "       margin: 0px;  /* this affects the margin on the content before sending to printer */"
    //     sHtml += "}</style >";
    //     sHtml += "<div><div style='transform:rotate(270deg);margin-top:130px;margin-left: -110px; font-family:'Times New Roman'; font-size: 18px;width: 325px;'>" + patientName + " ; " + dob;
    //     sHtml += "<br /> " + curTime + "</div></div>";
    //     const printWindow = window.open('', '', 'height= 900px, width=600px');
    //     printWindow.document.write(sHtml);
    //     printWindow.document.close();
    //     printWindow.print();
    // };

    // const handlePrintForAll = () => {
    //     // Check if there are selected rows
    //     if (!selectedRow || selectedRow.length < 1) {
    //         toast.error("No Patient Selected For Print");
    //         return;
    //     }

    //     // Create a hidden container for printing
    //     const printContainer = document.createElement("div");
    //     printContainer.style.display = "none"; // Hide it from view
    //     document.body.appendChild(printContainer);

    //     // Add patient details to the print container
    //     selectedRow.forEach(({ FirstName, LastName, DOB }) => {
    //         const now = new Date();
    //         const date = now.toLocaleDateString();
    //         const time = now.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
    //         const curTime = `${date} ; ${time}`;

    //         const patientDiv = document.createElement("div");
    //         patientDiv.innerHTML = `
    //             <div style="page-break-after: always; font-family: 'Times New Roman'; font-size: 18px; padding: 10px;">
    //                 <div style="transform:rotate(270deg); margin-top: 130px; margin-left: -110px;">
    //                     ${LastName} ${FirstName} ; ${DOB}<br />${curTime}
    //                 </div>
    //             </div>
    //         `;

    //         printContainer.appendChild(patientDiv);
    //     });

    //     // Print the content of the hidden container
    //     const printContent = printContainer.innerHTML;
    //     const newWindow = window.open('', '_blank');
    //     newWindow.document.write(`
    //         <html>
    //         <head>
    //             <style>
    //                 @media print {
    //                     @page {
    //                         margin: 0;
    //                     }
    //                     body {
    //                         font-family: 'Times New Roman', serif;
    //                         margin: 0;
    //                     }
    //                     .page-break {
    //                         page-break-after: always;
    //                     }
    //                 }
    //             </style>
    //         </head>
    //         <body>
    //             ${printContent}
    //         </body>
    //         </html>
    //     `);
    //     newWindow.document.close();
    //     newWindow.print();
    //     newWindow.onafterprint = () => newWindow.close();

    //     // Clean up the hidden container
    //     document.body.removeChild(printContainer);
    // };
    const handlePrintForAll = () => {
        const selectedRowData = filterIntelli?.filter((row) => selectedRows[row.PatientID]);

        if (selectedRowData?.length < 1) {
            toast.error("No Patient Selected For Print");
            return;
        }

        const printContainer = document.createElement("div");
        printContainer.style.display = "none"; // Hide it from view
        document.body.appendChild(printContainer);

        selectedRowData.forEach(({ FirstName, LastName, DOB }) => {
            const now = new Date();
            const date = now.toLocaleDateString();
            const time = now.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
            const curTime = `${date} ; ${time}`;

            const patientDiv = document.createElement("div");
            patientDiv.innerHTML = `
                <div style="page-break-after: always; font-family: 'Times New Roman'; font-size: 18px; padding: 10px;">
                    <div style="transform:rotate(270deg); margin-top: 130px; margin-left: -110px;">
                        ${LastName} ${FirstName} ; ${DOB}<br />${curTime}
                    </div>
                </div>
            `;

            printContainer.appendChild(patientDiv);
        });

        const printContent = printContainer.innerHTML;
        const newWindow = window.open('', '_blank');
        newWindow.document.write(`
            <html>
            <head>
                <style>
                    @media print {
                        @page {
                            margin: 0;
                        }
                        body {
                            font-family: 'Times New Roman', serif;
                            margin: 0;
                        }
                        .page-break {
                            page-break-after: always;
                        }
                    }
                </style>
            </head>
            <body>
                ${printContent}
            </body>
            </html>
        `);
        newWindow.document.close();
        newWindow.print();
        newWindow.onafterprint = () => newWindow.close();

        document.body.removeChild(printContainer);
    };
  const handlePrint = () => {
  const patientListEl = document.getElementById("patient-list");
    if (!patientListEl) {
      alert("Patient list not found!");
      return;
    }
    const printContent = patientListEl.outerHTML;
    const printWindow = window.open("", "_blank");
    printWindow.document.write(`
      <html>
        <head>
          <title>Patient List</title>
          <style>
            body { font-family: Arial, sans-serif; padding: 20px; }
            h2, p { text-align: center; margin: 0; }
            table { width: 100%; border-collapse: collapse; margin-top: 20px; }
            th, td { border: 1px solid #000; padding: 8px; text-align: left; }
            .hide-on-print { display: none; }
            .hidden, .print-hidden { display: none; }
        .header {
  display: table;
  width: 100%;
  border: 1px solid black;
  padding: 0.5rem;
  font-size: 0.875rem;
  font-weight: 600;
}

.header .left {
  display: table-cell;
  text-align: left;
}

.header .center {
  display: table-cell;
  text-align: center;
}
          </style>
        </head>
        <body>
        <div class="header">
     <div class="left">${user?.practiceName}</div>
     <div class="center">
    Date: ${DOS?.toLocaleDateString("en-US")} , ${new Date(DOS).toLocaleDateString("en-US", { weekday: "long" })}
  </div>
          </div>
          ${printContent}
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };

    const handleExcel = () => {
        if (dataTableRef.current) {
            const tableHtml = dataTableRef.current.innerHTML;
            const data = { PrintableData: tableHtml, PageName: "Patient List New" };
            request(`${process.env.REACT_APP_LOGIN_API_URL}/DataExport/Excel`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                data: JSON.stringify(JSON.stringify(data)),
            })
                .then((res) => {
                    const fileUrl = res[2]; // Assuming the URL is in the third position of the response array
                    if (fileUrl) {
                        // Create a temporary anchor element
                        window.open(fileUrl, "_blank");
                    } else {
                        throw new Error("No download URL provided");
                    }
                })
                .catch(() => {
                    toast.error("Error occured while fetching labs", {
                        autoClose: 3000,
                    });
                });
        }
        // Add your logic for Excel export here
    };

    const handlePdf = () => {
        if (dataTableRef.current) {
            const tableHtml = dataTableRef.current.innerHTML;
            const data = { PrintableData: tableHtml, PageName: "Patient List New" }; //static
            request(`${process.env.REACT_APP_LOGIN_API_URL}/DataExport/PDF`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                data: JSON.stringify(JSON.stringify(data)),
            })
                .then((res) => {
                    const fileUrl = res[2]; // Assuming the URL is in the third position of the response array
                    if (fileUrl) {
                        // Create a temporary anchor element
                        window.open(fileUrl, "_blank");
                    } else {
                        throw new Error("No download URL provided");
                    }
                })
                .catch(() => {
                    toast.error("Error occured while fetching labs", {
                        autoClose: 3000,
                    });
                });
        }
    };
    const filterIntelli =
        patientList &&
        Array.isArray(patientList) &&
        patientList?.filter((row) => {
            // console.log(row);

            const fullName = `${row.FirstName} ${row.LastName}`?.toLowerCase();
            const searchTermNormalized = searchTerm?.trim()?.toLowerCase();
            const dobMatches = row?.DOB?.toLowerCase().includes(
                dob?.toLowerCase(),
            );
            const insMatches = row?.Insurance?.toLowerCase().includes(
                searchIns?.toLowerCase(),
            );
            const policyMatches = row?.PolicyNumber?.toLowerCase().includes(
                policy?.toLowerCase(),
            );
            const locMatches = row?.LocationName?.toLowerCase().includes(
                location?.toLowerCase(),
            );
            return (
                fullName.includes(searchTermNormalized)
                &&
                dobMatches && insMatches && policyMatches && (locMatches || (!location && row?.LocationName === null))
            );
        });
    const handleSelectAll = () => {
        const newSelectedRows = {};
        if (Object.keys(selectedRows)?.length === filterIntelli?.length) {
            // Deselect all if all are selected
            setSelectedRows({});
        } else {
            // Select all rows
            filterIntelli.forEach((row) => {
                newSelectedRows[row.PatientID] = true;
            });
            setSelectedRows(newSelectedRows);
        }
    };

    const handleRowSelect = (row) => {
        const newSelectedRows = { ...selectedRows };
        if (newSelectedRows[row.PatientID]) {
            delete newSelectedRows[row.PatientID]; // Deselect
        } else {
            newSelectedRows[row.PatientID] = true; // Select
        }
        setSelectedRows(newSelectedRows);
    };

    const filteredData =
        searchTerm || dob || searchIns || policy || location
            ? filterIntelli
            : patientList;
    console.log(selectedRows);

    return (
        <>
            <style>{`
 @media print {
  body * {
    visibility: hidden;
  }

  .print-area, .print-area * {
    visibility: visible;
  }

  .print-area {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
  }

  .hide-on-print {
    display: none !important;
  }

  .print-hidden {
    display: none !important;
  }
}
  `}</style>
            <header className="bg-blue-200 text-black p-4 flex items-center w-full">
                <div className="flex items-center justify-between space-x-4 w-full">
                    <div className='flex flex-row items-center justify-center gap-8'>
                        <label
                            htmlFor="DOS"
                            className="block text-md font-medium text-white-300"
                        >
                            DOS:
                        </label>
                        <input
                            type="date" // Use type text to allow MM/DD/YYYY format
                            id="DOS"
                            value={formatDateForInput(DOS)} // Format for display as MM/DD/YYYY
                            onChange={(e) => {
                                const dateString = e.target.value;
                                const newDate = parseDateString(dateString);
                                if (newDate) {
                                    setDOS(newDate); // Update the state with Date object
                                    setError(""); // Clear any previous errors
                                } else {
                                    setError("Invalid date format.");
                                }
                            }}
                            className="mt-1 block w-[200px] px-3 py-2 border border-gray-600 rounded-md bg-white text-black shadow-sm focus:outline-none focus:ring focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                        />
                        <button
                            onClick={getPatientList}
                            className="flex items-center bg-orange text-white py-2 px-4 rounded-md shadow-sm focus:outline-none"
                        >
                            <FaSearch className="mr-2" />
                            Search
                        </button>
                    </div>
                    <div className="flex justify-between gap-8">
                        <button style={{ color: 'white' }}
                            onClick={handlePrintForAll}
                            className="text-blue-700 hover:text-blue-700 flex flex-col items-center transition-colors"
                            title="Print"
                        >
                            <FaPrint size={24} className='text-blue-500' />
                            <span className='text-blue-500'>Print Patient Data</span>
                        </button>
                         <button
        style={{ color: "white" }}
        onClick={handlePrint}
        className="text-blue-700 hover:text-blue-700 flex flex-col items-center transition-colors"
        title="Print"
      >
        <FaPrint className='text-blue-500' size={24} />
        <span className='text-blue-500'>Print Pat List</span>
      </button>
                        {/* <button
                            onClick={() => window.print()}
                            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 hide-on-print"
                        >
                            Print Table
                        </button> */}
                        <button style={{ color: 'white' }}
                            onClick={handleExcel}
                            className="text-green-500 hover:text-green-700 flex flex-col items-center transition-colors"
                            title="Export to Excel"
                        >
                            <AiOutlineFileExcel className='text-green-700 hover:text-green-700' size={24} />
                            <span className='text-green-700 hover:text-green-700'>Export as Excel</span>
                        </button>
                        <button style={{ color: 'white' }}
                            onClick={handlePdf}
                            className="text-red-500 hover:text-red-700 flex flex-col items-center transition-colors"
                            title="Export to PDF"
                        >
                            <MdPictureAsPdf className='text-red-500 hover:text-red-700' size={24} />
                            <span className='text-red-500 hover:text-red-700'>Export as PDF</span>
                        </button>
                    </div>
                    <div></div>
                </div>
            </header>
                <div className="hide-on-print bg-gray-200 p-2">
        <label>
          <input
            type="checkbox"
            checked={printVisibleColumns?.length === columns?.length}
            onChange={(e) =>
              setPrintVisibleColumns(
                e.target.checked ? columns.map((col) => col.key) : []
              )
            }
          /> Select All
        </label>
        <div className="flex flex-wrap gap-4">
          {columns.map(({ key, label }) => (
            <label key={key} className="flex items-center gap-2">
              <input
                type="checkbox"
                checked={printVisibleColumns.includes(key)}
                onChange={() =>
                  setPrintVisibleColumns((prev) =>
                    prev.includes(key)
                      ? prev.filter((k) => k !== key)
                      : [...prev, key]
                  )
                }
              />
              {label}
            </label>
          ))}
        </div>
      </div>
      <div ref={dataTableRef} id="patient-list" className="print-area">
        <table className="min-w-full bg-white border border-gray-300">
          <thead>
  <tr className="bg-[#005d97] border-b border-black text-white">
    <th className="p-2 border-r border-black">#</th>
    {columns
      .filter((col) => printVisibleColumns.includes(col.key))
      .map((col) => (
        <th
          key={col.key}
          className="p-2 border-r border-black"
          style={{ whiteSpace: "nowrap" }}
        >
          {col.label} <br />
          {col.filter !== undefined && (
            <input
              type="text"
              className="text-gray-800 text-sm mt-1 hide-on-print w-11/12"
              placeholder="Search"
              value={col.filter}
              onChange={(e) => col.onChange(e.target.value)}
              style={{ marginBottom: "10px", padding: "5px" }}
            />
          )}
        </th>
      ))}
    <th className="p-2 border-r border-black hide-on-print" style={{ whiteSpace: "nowrap" }}>
      Select <br />
      <input
        type="checkbox"
        checked={Object.keys(selectedRows)?.length === filteredData?.length}
        onChange={handleSelectAll}
      />
    </th>
  </tr>
</thead>
<tbody>
  {filteredData?.length === 0 ? (
    <tr>
      <td colSpan={columns?.length + 1} className="text-center p-4">
        No Patient Found On This Specified Date
      </td>
    </tr>
  ) : (
    filteredData?.map((row, index) => (
      <tr key={index} className="border-b border-black font-medium text-md">
        <td className="p-2 border-r border-black">{index + 1}</td>
        {columns
          .filter((col) => printVisibleColumns.includes(col.key))
          .map((col) => (
            <td
              key={col.key}
              className="p-2 border-r border-black"
              style={{ whiteSpace: "nowrap" }}
            >
              {col.render ? col.render(row, index) : col.accessor(row)}
            </td>
          ))}
        <td className="p-2 border-r border-black hide-on-print">
          <input
            type="checkbox"
            checked={!!selectedRows[row.PatientID]}
            onChange={() => handleRowSelect(row)}
          />
        </td>
      </tr>
    ))
  )}
</tbody>
        </table>
      </div>
        </>
    )
}

export default PatientList
